__turbopack_context__.v({
  "root": "SocialMediaLink-module__Weywba__root",
});
